import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#F7F5F0] grid place-items-center px-6">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-lg text-center">
        <h1 data-testid="payment-cancel-heading" className="font-serif text-5xl lg:text-6xl tracking-tighter leading-[1]">
          No rush. <span className="italic text-[#B85C38]">Your place waits.</span>
        </h1>
        <p className="mt-5 text-[#595550] text-lg leading-relaxed">
          Your checkout was cancelled and you have not been charged. Whenever you're ready to hold your spot in the circle, we'll be here.
        </p>
        <Link to="/#reserve" data-testid="back-reserve" className="reserve-cta inline-block mt-10 bg-[#2C2A28] text-[#F7F5F0] px-8 py-4 rounded-full font-mono-a text-xs uppercase tracking-[0.2em] hover:bg-[#B85C38]">
          Back to reservation
        </Link>
      </motion.div>
    </div>
  );
}
